/* PROJEKT ALPHA — Motion-Schicht (Scroll-Reveals)
   Differenzierte Entrances statt Einheits-Fade:
   – Text-/Button-Blöcke steigen mit Blur auf, gestaffelt pro Section
   – Bild-/Video-Blöcke settlen mit leichtem Scale
   – Produktkarten staggern pro Zeile
   – Hero hat eine eigene CSS-Entrance (nautiq-motion.css)
   Reduced Motion: keine Reveals, Autoplay-Videos werden pausiert (Poster bleibt).
   Failure-Mode: ohne JS bleibt alles sichtbar (Klassen werden nur per JS gesetzt). */
(function () {
  function deEmoji() {
    try {
      var root = document.getElementById('MainContent');
      if (!root) return;
      var star = /⭐/g;
      var others = /[\u{1F4E6}\u{1F576}\u{1F512}\u{1F9FD}\u{1F381}\u{1F69A}\u{1F4EC}\u{1F50D}\u{1F4CB}\u{1F4B3}]️?/gu;
      var arrows = /↩️?/g;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      var nodes = [];
      while ((n = w.nextNode())) nodes.push(n);
      nodes.forEach(function (t) {
        var v = t.nodeValue;
        if (!v) return;
        var nv = v.replace(star, '★').replace(others, '✦').replace(arrows, '✦');
        if (nv !== v) t.nodeValue = nv;
      });
    } catch (e) {}
  }

  function motionScale() {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--alpha-motion-scale');
      var n = parseFloat(v);
      return isNaN(n) ? 1 : n;
    } catch (e) { return 1; }
  }

  function pauseAutoplayVideos() {
    try {
      document.querySelectorAll('#MainContent video[autoplay]').forEach(function (v) {
        try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
      });
    } catch (e) {}
  }

  function init() {
    deEmoji();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pauseAutoplayVideos();
      return;
    }
    var scale = motionScale();
    if (scale === 0) return;

    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('nq-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      var prep = function (el, delayMs, media) {
        if (el.classList.contains('nq-r') || el.classList.contains('nq-r-media')) return;
        el.classList.add(media ? 'nq-r-media' : 'nq-r');
        if (delayMs) el.style.setProperty('--nq-delay', Math.round(delayMs * scale) + 'ms');
        io.observe(el);
      };

      document.querySelectorAll('#MainContent .shopify-section').forEach(function (s) {
        if (s.classList.contains('hero-wrapper')) return; /* eigene CSS-Entrance */
        if (s.querySelector('marquee-component')) return; /* läuft bereits */

        /* Karten zuerst (damit Eltern-Container sie erkennen) */
        var cards = s.querySelectorAll('.product-card, .resource-card, .collection-card');
        cards.forEach(function (c, i) { prep(c, (i % 4) * 80, false); });

        /* Inhalts-Kinder gestaffelt — Medien anders als Text */
        var idx = 0;
        var groups = s.querySelectorAll('.section-content-wrapper, .section-resource-list__header');
        groups.forEach(function (g) {
          Array.prototype.forEach.call(g.children, function (child) {
            if (child.querySelector && child.querySelector('.nq-r, .nq-r-media')) return; /* enthält schon Reveals */
            var isMedia = child.classList.contains('image-block') || child.classList.contains('video-block');
            prep(child, Math.min(idx * 90, 450), isMedia);
            idx++;
          });
        });

        /* Fallback: nichts erkannt → Section als Ganzes, ruhig */
        if (idx === 0 && cards.length === 0) prep(s, 0, false);
      });
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
